// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__EsdF2","Tag__content":"Tag_Tag__content__dO0E4"};